import { Routes, Route } from "react-router-dom";
import ProfileScreen from "../pages/user/ProfileScreen";
import InterviewPackScreen from "../pages/user/InterviewPackScreen";
import InterviewListScreen from "../pages/user/InterviewListScreen"
import TestScreen from "../pages/user/TestScreen";
import CheckResultScreen from "../pages/user/CheckResultScreen";
import ViewAnswersScreen from "../pages/user/ViewAnswersScreen";
import BillingScreen from "../pages/user/BillingScreen";
import PurchaseHistoryScreen from "../pages/user/PurchaseHistoryScreen"
import SendReviewScreen from "../pages/user/SendReviewScreen"
import FAQScreen from "../pages/user/FAQScreen";
import AboutPage from "../pages/user/AboutPage";
import ContactUs from "../pages/user/ContactUs";

export default function UserRoutes() {
    return (
        <Routes>
            <Route path="/profile" element={<ProfileScreen />} />
            <Route path="/packs" element={<InterviewPackScreen />} />
            <Route path="interviews/:domainId/:packId/:packName" element={<InterviewListScreen />} />
            <Route path="test/:domainId/:packId/:interviewId" element={<TestScreen />} />
            <Route path="checkresult/:domainId/:packId/:interviewId" element={<CheckResultScreen />} />
            <Route path="viewanswers/:domainId/:packId/:interviewId" element={<ViewAnswersScreen />} />
            <Route path="/billing/:domainId/:packId" element={<BillingScreen />} />
            <Route path="/purchases/" element={<PurchaseHistoryScreen />} />
            <Route path="/send-review" element={<SendReviewScreen />} />
            <Route path="/faq" element={<FAQScreen />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactUs />} />
        </Routes>
    );
}
